import React from "react";
import styled from "styled-components";
import { Card, CardContent } from "components/ui/Card";
import type { MemberMetric } from "types/BusinessDashboard";
import { MembersChangeIndicator } from "./members-change-indicator";
import { HelpIcon } from "assets/icons/system";
import { BusinessDashboardHelpHoverCard } from "components/businessDashboard/ui-kit/help-modal";

const StyledCard = styled(Card)<{ $bgColor: string }>`
  border: 0;
  padding: 0;
  border-radius: 8px;
  box-shadow: none;
  background-color: ${({ $bgColor }) => $bgColor};
`;

const StyledCardContent = styled(CardContent)<{ $big?: boolean }>`
  padding: ${({ $big }) => ($big ? "0 8px" : "12px 16px")};
`;

const SpaceY = styled.div<{ $big?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $big }) => ($big ? "4px" : "6px")};
`;

const HelpButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  cursor: pointer;
  background: none;
  border: none;
  transition: color 0.2s;
  &:hover {
    color: #fff;
  }
`;

const Title = styled.p<{ $color: string }>`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: ${({ $color }) => $color};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const StatContent = styled.div<{ $big?: boolean }>`
  display: flex;
  flex-direction: ${({ $big }) => ($big ? "row" : "column")};
  gap: ${({ $big }) => ($big ? "7px" : "0")};
`;

const StatValue = styled.span<{ $big?: boolean }>`
  font-size: ${({ $big }) => ($big ? "27.99px" : "18px")};
  font-weight: bold;
  line-height: ${({ $big }) => ($big ? "34.99px" : "28px")};
  letter-spacing: ${({ $big }) => ($big ? "-0.35px" : "-0.4px")};
  color: #333333;
`;

const ChangeRow = styled.div<{ $big?: boolean; $isPositive: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 15px;
  font-weight: bold;
  line-height: 22px;
  letter-spacing: -0.2px;
`;

export const MembersStatCard = ({
  title,
  metric,
  color,
  bgColor = "white",
  className,
  big,
}: {
  title: string;
  metric?: MemberMetric;
  color: string;
  bgColor?: string;
  className?: string;
  big?: boolean;
}) => {
  if (!metric) return null;
  const isPositive =
    (metric.changeRateComparedToPreviousMonth?.value ?? 0) >= 0;

  return (
    <StyledCard $bgColor={bgColor} className={className}>
      <StyledCardContent $big={big}>
        <SpaceY $big={big}>
          <Title $color={color}>
            {title}
            {title === "전체 유효 회원수" ? (
              <BusinessDashboardHelpHoverCard type="totalActiveMembers">
                <HelpButton type="button">
                  <HelpIcon />
                </HelpButton>
              </BusinessDashboardHelpHoverCard>
            ) : (
              ""
            )}
          </Title>
          <StatContent $big={big}>
            <StatValue $big={big}>{metric.count.toLocaleString()}명</StatValue>
            <ChangeRow $big={big} $isPositive={isPositive}>
              <MembersChangeIndicator changeRate={metric.changeRate} />
            </ChangeRow>
          </StatContent>
        </SpaceY>
      </StyledCardContent>
    </StyledCard>
  );
};
